import Moment from "moment";
import { extendMoment } from "moment-range";
const moment = extendMoment(Moment as any);

//All params are moment objects
export const inRange = (date: any, minDate: any, maxDate: any) => {
  //Create a reange
  const range = moment.range(minDate, maxDate),
    //Then check if it contains the incoming date.
    inRange = range.contains(date);
  return inRange;
};
